import RytmWebflow from 'rytm-webflow';
import gsap from 'gsap';
import { odometer, odometerStart } from '../shared/odometer';
import { classNames } from '../constants';

class ChapterIntroController extends RytmWebflow.Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.initOdometers();
  }
  addEventListeners() {
    super.addEventListeners();
  }
  removeEventListeners() {
    super.removeEventListeners()
  }
  // ### Custom
  initOdometers = () => { 
    document.body.classList.remove(classNames.CHAPTER_INTRO_HIDDEN);
    document.body.classList.remove(classNames.CHAPTER_INTRO_HIDE);
    // look for chapter intro odometers
    const container = document.querySelector(this.getContainerSelector());
    const list = [...container.querySelectorAll('.r-odometer')];
    if (list.length < 1) {
      return;
    }
    list.forEach( (el, index) => {
      const events = {
        onComplete: this.onOdometerComplete,
      }
      odometer(el, false, events);
      // animate IN
      gsap.to(el, {
        delay: 1.2,
        onComplete: () => {
          // // reference another ASWAP controller to hide VIEW
          // const asOpeningController = this.getAswapOpeningController();
          // if (asOpeningController) {
          //   asOpeningController.view.hide(asOpeningController.view.container);
          // }
          odometerStart(el);
        }
      })
    });
  }
  // Odometer complete...
  onOdometerComplete = () => {
    document.body.classList.add(classNames.CHAPTER_INTRO_HIDE);
    const container = document.querySelector(this.getContainerSelector());
    const items = [...container.querySelectorAll('.r-odometer > span')];
    // reference another ASWAP controller to show VIEW
    const asOpeningController = this.getAswapOpeningController();
    if (asOpeningController) {
      // wait...
      setTimeout(() => {
        // show view
        document.body.classList.add(classNames.CHAPTER_READY);
        asOpeningController.view.show(asOpeningController.view.container);
      }, 1300)
    }
    gsap.to(items, {
      y: "-150%",
      duration: .85,
      delay: .8,
      ease: 'power2.easeIn',
      stagger: .03,
      onComplete: () => {
        document.body.classList.add(classNames.CHAPTER_INTRO_HIDDEN);
        document.body.classList.remove(classNames.CHAPTER_INTRO_HIDE);
      },
    });
  }
  getAswapOpeningController = () => {
    const container = document.querySelector(this.getContainerSelector());
    const openingControlelrId = container.dataset.openingControllerId;
    return openingControlelrId ? this.getAswapControllerById(openingControlelrId) : null;
  }
  getAswapControllerById = (id) => {
    let result = null;
    RytmWebflow.aswap.controllers.forEach( (controller) => { 
      if (controller.id === id) {
        result = controller?.controller;
        return result;
      }
    });
    return result;
  }
  

}

export default ChapterIntroController;